const calculatedDrivers = `${process.env.VUE_APP_URL}/api/v1/dimension/calculated-drivers/`;

export default {
  namespaced: true,
  state: {
    baseUrl: (scenario, limit, order, offset) => `${process.env.VUE_APP_URL}/api/v1/dimension/calculated-drivers/get-calculated/?scenario=${scenario}&limit=${limit}${order}${offset}`,
    previousUrl: null,
    nextUrl: null,
    currentUrl: null,
    count: null,
    pageLength: 10,
    offset: 0,
    columns: [
      {
        label: "Name",
        field: "name",
      },
      {
        label: "Dimension",
        field: "dimension_name",
      },
      {
        label: "Formula",
        field: "formula",
      },
      {
        label: "Total value",
        field: "total_value",
        formatFn: (value) => {
          if (isNaN(value) || value == null) {
            return "-";
          }
          return `${parseFloat(value).toFixed(2)}`;
        },
      },
      {
        label: "Is P&L",
        field: "is_pnl_line",
      },
      {
        label: "",
        field: "manage",
      },
    ],
    rows: [],
    orderField: '',
    orderDict:{
      name:"name",
      dimension_name:"dimension__name",
      formula:"formula",
      is_pnl_line:"is_pnl_line",
      total_value:"total",
      type:"type",
    },
    calculatedDriversListByModelPnl: [],
    calculatedDriverForm: {
      dimension: null,
      name: "",
      formula: "",
      type: "DECI",
      is_pnl_line: false
    },
    
    currentExportDriver: null,
    filesExport: [],

    calculations:{
      rows:[],
      errors:[]
    }
  },
  mutations: {
    SET_OFFSET(state, data) {
      state.offset = state.pageLength * data.currentPage - state.pageLength < 0 ? 0 : state.pageLength * data.currentPage - state.pageLength
    },
    SET_CURRENT_EXPORT_DRIVER(state,data){
      state.currentExportDriver = data;
    },
    SET_FILES_EXPORT(state, data){
      state.filesExport = data;
    },
    SET_CALCULATED_DRIVERS_LIST_BY_MODEL(state, data) {
      state.calculatedDriversListByModelPnl = data;
    },
    SET_DRIVER_DIMENSION(state, data) {
      state.calculatedDriverForm.dimension = data;
    },
    SET_DRIVER_NAME(state, data) {
      state.calculatedDriverForm.name = data;
    },
    SET_DRIVER_FORMULA(state, data) {
      state.calculatedDriverForm.formula = data;
    },
    SET_DRIVER_IS_PNL_LINE(state, data) {
      state.calculatedDriverForm.is_pnl_line = data;
    },
    CLEAR_DRIVER_FORM(state, data) {
      state.calculatedDriverForm = {
        dimension: null,
        name: "",
        formula: "",
        type: "DECI",
        is_pnl_line: false
      }
    },
    SET_CALCULATED_DRIVER_FORM(state, data) {
      state.calculatedDriverForm = data
    },

    SET_COUNT(state, data) {
      state.count = data;
    },
    SET_NEXT(state, data) {
      state.nextUrl = data;
    },
    SET_PREVIOUS(state, data) {
      state.previousUrl = data;
    },
    SET_CURRENT_URL(state, data) {
      state.currentUrl = data;
    },
    SET_ROWS(state, data) {
      if(!data){
        return;
      }
      state.rows = data;
    },
    SET_PAGE_LENGTH(state, data) {
      state.pageLength = data;
    },
    CLEAR_TABLE_DATA(state, data){
      state.rows = [];
    },
    SET_CALCULATION_ROWS(state, data){
      state.calculations.rows = data
    },
    SET_CALCULATION_ERRORS(state, data){
      state.calculations.errors = data
    },
    SET_ORDER_FIELD(state, data){
      switch(data.orderType){
        case 'asc':
          state.orderField = state.orderDict[data.orderField];
          break;
        case 'desc':
          state.orderField = `-${state.orderDict[data.orderField]}`;
          break;
        default:
          state.orderField = null;
          break;
      }
    }
  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId }) {
      let order = state.orderField ? `&ordering=${state.orderField}` : '' 
      let offset = state.offset ? `&offset=${state.offset}` : ''
      let getData = 
        state.currentUrl || state.baseUrl(scenarioId, state.pageLength, order, offset);

      context.$http.get(getData).then((res) => {
        commit("SET_COUNT", res.data.count);
        commit("SET_NEXT", res.data.next);
        commit("SET_PREVIOUS", res.data.previous);
        commit("SET_ROWS", res.data.results);
      });
    },
    setNextAsCurrent({ state, commit }, { }) {
      commit("SET_CURRENT_URL", state.nextUrl);
    },
    setPreviousAsCurrent({ state, commit }, { }) {
      commit("SET_CURRENT_URL", state.previousUrl);
    },
    getCalculatedDrivers({ commit }, { context, model }) {
      const urlGetCalculatedDrivers = `${calculatedDrivers}?model=${model}&is_pnl_line=True`;
      return context.$http.get(urlGetCalculatedDrivers).then((res) => {
        commit("SET_CALCULATED_DRIVERS_LIST_BY_MODEL", res.data);
      });
    },
    createUpdateCalculatedDriver({ state }, { context, mode }) {
      if (mode == "UPDATE") {
        return context.$http.patch(`${calculatedDrivers}${state.calculatedDriverForm.id}/`, { ...state.calculatedDriverForm });
      }
      return context.$http.post(calculatedDrivers, { ...state.calculatedDriverForm });
    },
    deleteDriver({ state }, { context, id }) {
      return context.$http.delete(`${calculatedDrivers}${id}/`)
    },
    calculate({ state }, { context, scenarioId }) {
      state.rows.forEach((driver) => {
        driver.total_value = null;
      })
      return context.$http.post(`${calculatedDrivers}calculate/`, { scenario: scenarioId })
    },
    getDriverFiles({state, commit}, {context, scenario}){
      const driverId = state.currentExportDriver.id;
      context.$http.get(`${process.env.VUE_APP_URL}/api/v1/export/files/?scenario=${scenario}&data_type=RECORDS_ONLY_CALCULATED&driver=${driverId}`)
        .then((res) => {
          commit("SET_FILES_EXPORT", res.data);
        })
        .catch(err => {
          if(!err.response.status == 400){
            console.log(err);
          }
        })
    },
    updateCalculation({state, commit, dispatch}, {context, scenario}){
      const url = `${process.env.VUE_APP_URL}/api/v1/dimension/drivers-calculation/?scenario=${scenario}`;
      context.$http.get(url)
        .then((res) => {
          commit("SET_CALCULATION_ROWS", res.data);
          dispatch("getTableData", {
            context: context,
            scenarioId: scenario,
          });
          if(res.data.length>0 && res.data[0].calculation_id){
            const errorsUrl = `${process.env.VUE_APP_URL}/api/v1/dimension/drivers-issues/?calculation=${res.data[0].calculation_id}`;
            return context.$http.get(errorsUrl)
            .then((res) => {
              commit("SET_CALCULATION_ERRORS", res.data);
            })
          }
        })
    }
  }
}
